import { ICalendarHolidayData, ITimeOffCalendarData } from '@/models';
import {
  ITimeOffCalendarService,
  IFetchCalendarHolidaysParams,
  IUploadCalendarHolidaysParams
} from './timeoff-calendar.types';
import { AxiosInstance } from 'axios';
import { objectToFormData } from '@/utils/objectToFormData';

export class TimeOffCalendarService implements ITimeOffCalendarService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/timeoffs/calendars/';
  }

  fetchTimeOffCalendars(): Promise<ITimeOffCalendarData[]> {
    return this.axios
      .get<ITimeOffCalendarData[]>(`${this.endpoint}`)
      .then(({ data }) => data);
  }

  fetchTimeOffCalendar(id: number): Promise<ITimeOffCalendarData> {
    return this.axios
      .get<ITimeOffCalendarData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createTimeOffCalendar(
    data: ITimeOffCalendarData
  ): Promise<ITimeOffCalendarData> {
    return this.axios
      .post<ITimeOffCalendarData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateTimeOffCalendar(
    data: ITimeOffCalendarData
  ): Promise<ITimeOffCalendarData> {
    return this.axios
      .patch<ITimeOffCalendarData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteTimeOffCalendar(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }

  //Holiday
  fetchCalendarHolidays(
    params: IFetchCalendarHolidaysParams
  ): Promise<ICalendarHolidayData[]> {
    const queryParams = params.year
      ? {
          params: {
            year: params.year
          }
        }
      : undefined;

    return this.axios
      .get<ICalendarHolidayData[]>(
        `${this.endpoint}${params.calendarId}/holidays/`,
        queryParams
      )
      .then(({ data }) => data);
  }

  fetchCalendarHoliday(
    calendarId: number,
    holidayId: number
  ): Promise<ICalendarHolidayData> {
    return this.axios
      .get<ICalendarHolidayData>(
        `${this.endpoint}${calendarId}/holidays/${holidayId}/`
      )
      .then(({ data }) => data);
  }

  createCalendarHoliday(
    calendarId: number,
    data: ICalendarHolidayData
  ): Promise<ICalendarHolidayData> {
    return this.axios
      .post<ICalendarHolidayData>(
        `${this.endpoint}${calendarId}/holidays/`,
        data
      )
      .then(({ data }) => data);
  }

  updateCalendarHoliday(
    calendarId: number,
    data: ICalendarHolidayData
  ): Promise<ICalendarHolidayData> {
    return this.axios
      .patch<ICalendarHolidayData>(
        `${this.endpoint}${calendarId}/holidays/${data.id}/`,
        data
      )
      .then(({ data }) => data);
  }

  deleteCalendarHoliday(calendarId: number, holidayId: number): Promise<any> {
    return this.axios.delete(
      `${this.endpoint}${calendarId}/holidays/${holidayId}/`
    );
  }

  uploadCalendarHolidays(
    data: IUploadCalendarHolidaysParams
  ): Promise<ICalendarHolidayData[]> {
    const formData = objectToFormData({ file: data.file });
    return this.axios
      .post<ICalendarHolidayData[]>(
        `${this.endpoint}${data.calendarId}/holidays/upload/`,
        formData,
        {
          params: { year: data.year }
        }
      )
      .then(({ data }) => data);
  }
}
